<template>
    <router-link
            class="c-product-line c-product-line--customer u-fullwidth u-text-align-left c-order-line c-product-line-header"
            :class="{'pre-order': ['PREOR', 'OPTIONAL'].includes(order.SalesPool)}"
            :to=to>
        <div>
            <em>{{ $t('order.line.order_number') }}</em><br>
            <span>{{ order.OrderNumber }}</span>
        </div>
        <div class="c-product-line-header__item">
            <em>{{ $t('order.line.created') }}</em>
            <strong>{{ order.OrderDate | moment('DD-MM-YYYY') }}</strong>
        </div>
        <div v-if="!isMarketing" class="c-product-line-header__item">
            <em>{{ $t('order.line.total_price') }}</em>
            <strong>{{ order.Total | currency(customerCurrencySymbol) }}</strong>
        </div>
        <div class="c-product-line-header__item">
            <em>{{ $t('order.line.status') }}</em>
            <strong>{{ order.Status }}</strong>
        </div>
      <div class="c-product-line-header__item">
        <em v-if="['PREOR', 'OPTIONAL'].includes(order.SalesPool)">{{ $t('order.line.preorder') }}</em>
        <em v-if="['REORD', 'WEBORD'].includes(order.SalesPool)">{{ $t('order.line.reorder') }}</em>
      </div>
        <div class="c-product-line-header__item">
            <svgicon v-if="order.IsDropshipment" width="1.4em" height="1.4em" name="dropshipment"></svgicon>
        </div>
        <svgicon width=".4em" height=".4em" name="arrow-rounded" class="c-product-line__arrow"></svgicon>
    </router-link>
</template>

<script>
    import Vue from 'vue'
    import VProductSizeInput from '@/components/product/widgets/productSizeInput'

    export default {
        props: ['order', 'to'],
        components: {
            VProductSizeInput
        },
        computed: {
            isMarketing() {
                return this.$store.getters.isMarketing;
            },
            customerCurrencySymbol() {
                return this.$store.getters.userInfo.customerCurrencySymbol;
            }
        },
        data() {
            return {}
        },
    }
</script>

<style lang="scss" scoped>

    @import "~@/assets/scss/private";

    .c-order-line {
        &,
        &:visited,
        &:hover {
            color: inherit;
            text-decoration: inherit;
            transition: border-color .15s ease-out;
        }

        &:hover {
            border-color: $color-alpha;
        }
    }

    .c-product-line--customer {
        border: 1px solid palette(color-neutral, medium);

        &:not(:last-child) {
            margin-bottom: em($global-spacing-unit-small);
        }

        &.is-open {
            border-color: palette(color-neutral, medium-dark);
        }
    }

    .c-product-line__arrow {
        justify-self: flex-end;
        fill: $color-alpha;
        transition: transform .15s ease-out;

        a:hover & {
            transform: translateX(5px);
        }
    }

    .c-product-line-header {
        padding: em($global-spacing-unit-small) em($global-spacing-unit);
        display: grid;
        grid-auto-flow: column;
        align-items: center;
        grid-gap: em($global-spacing-unit);

        img {
            width: 60px;
        }

        &__item {
            color: palette(color-base, medium);
            line-height: 1.25;
            em {
                font-style: normal;
                display: block;
                @include rfs($font-size-tiny);
            }
            strong {
                font-weight: $medium;
            }
        }
    }

    .pre-order {
      border-color: $color-beta;
    }

</style>



// WEBPACK FOOTER //
// src/components/order/OrderLine.vue